import { createFetch } from '@vueuse/core';
import { computed } from 'vue';
import { MONO_API } from '@/config/appConfig';

export default (owner) => {
  const fetch = createFetch({
    baseUrl: MONO_API,
    options: {
      async beforeFetch(req) {
        if (owner) {
          req.options.headers['Tgb-Owner'] = owner;
        }
      },
    },
    fetchOptions: {
      mode: 'cors',
      headers: {
        'Content-Type': 'application/json',
      },
    },
  });

  /**
   * Get a single Poll by ID.
   * @param {number|Ref<number>} pollId - The ID of the poll to retrieve.
   * @returns {Promise<Object>} - A promise that resolves to the poll data.
   */
  const getPollById = (pollId, query = {}, opts = {}) => {
    const querystring = new URLSearchParams(
      Object.entries(query ?? {}).filter(([, value]) => (
        value !== undefined && value !== null && value !== ''
      )),
    ).toString();

    const url = computed(() => (
      `/public/polls/${pollId?.value || pollId}${querystring ? `?${querystring}` : ''}`
    ));

    return fetch(url, opts).get().json();
  };

  /**
    * Endpoint: POST https://mono.tagboard.cloud/public/polls/vote
    * Request Params:
    * pollId - ID of the poll
    * voteData - Object containing the vote data, e.g. { questionId: '123', answerId: '456' }
    * voteData.sessionId - required session ID for the vote
    * voteData.pollId - required poll ID for the vote
    * voteData.pollRoundId - required poll round ID for the vote
    * voteData.pollQuestionId - required poll question ID for the vote
    * voteData.optionId - Optional option ID for the vote (if standard poll)
    * voteData.fingerprint - Optional fingerprint for the vote (possible future use)
    * voteData.rating - Optional rating for the vote (if rating poll)
    * opts - Additional options for the createFetch function, such as headers or other fetch options
    * response - 200 OK or an error message
   */
  const postVote = (voteData, opts = {}) => {
    const url = computed(() => '/public/polls/vote');
    return fetch(url, opts).post(voteData).text();
  };

  /**
   * Endpoint: GET https://mono.tagboard.cloud/public/polls/{pollId}/questions/{questionId}
   * Request Params:
   *   pollId - ID of the poll
   *   questionId - ID of the question
   * Response - JSON object containing the results of the question
   * Example response:
   * {
   *   "results": [
   *     {
   *       "pollOptionId": 762,
   *       "votes": "17" // yuk we should use numbers here
   *     },
   *     {
   *       "pollOptionId": 763,
   *       "votes": "11" // yuk we should use numbers here
   *     }
   *   ]
   * }
   */
  const getQuestionResultsById = (pollQuestionId, opts = {}) => {
    const url = computed(() => (
      `public/polls/results?pollQuestionId=${pollQuestionId.value || pollQuestionId}`
    ));

    return fetch(url, opts).get().json();
  };

  return {
    getPollById,
    postVote,
    getQuestionResultsById,
  };
};
